import {EditableFieldModel} from "@white-label/components/page-builder/models/edit-component.model";
import {FieldType} from "@white-label/components/page-builder/models/model.map";

export class ReviewsModel {

        reviews =  new EditableFieldModel('reviews', FieldType.array, [
            new OneReview(),
            new OneReview(),
            new OneReview(),
            new OneReview(),
            new OneReview(),
            new OneReview(),
        ], OneReview);
        fieldsMap = [this.reviews];
        constructor(data?: {reviews?: any}) {
            if(data?.reviews){
                this.reviews.value = [];
                for(let review of data?.reviews.value){
                    this.reviews.value.push(new OneReview(review));
                }
            }
        }

}

export class OneReview {
    nickname = new EditableFieldModel('nickname', FieldType.text, 'Author name');
    review = new EditableFieldModel('review', FieldType.text, 'Amazing review for amazing thing');

    fieldsMap = [this.nickname, this.review];
    constructor(data?: {nickname?: any, review?: any}) {
        if(data?.nickname){
            this.nickname.value = data.nickname.value;
        }
        if(data?.review){
            this.review.value = data.review.value;
        }
    }
}